import { Link } from "react-router-dom";
import React, { useState } from "react";
const BoekingenMenu = ({ token, username }) => {
  const [isActive, setIsActive] = useState(false);
  if (username.bedrijf && username.bedrijf.modules.includes("ervaringen")) {
    if (token.role === "admin" || token.role === "manager" || token.role === "medewerker" || token.role === "ervaringeigenaar") {
      return (
        <li className="treeview">
          <a className="cursurhand" onClick={() => setIsActive(!isActive)}>
            <i className="fa fa-warehouse" />
            <span>Beheer Boekingen</span>
            <span className="pull-right-container">
              <i className="fa fa-angle-left pull-right" />
            </span>
          </a>
          <ul className={isActive ? "treeview-menu menu-open" : "treeview-menu "}>
            <li>
              <Link to="/boekingen" onClick={() => setIsActive(!isActive)}>
                <i className="fa fa-warehouse" />
                <span>Nieuwe Boekingen</span>
              </Link>
            </li>
            <li>
              <Link to="/boekingen/financieel" onClick={() => setIsActive(!isActive)}>
                <i className="fa fa-euro" />
                <span>Financieel</span>
              </Link>
            </li>
          </ul>
        </li>
      );
    } else {
      return null;
    }
  } else {
    return null;
  }
};
export default BoekingenMenu;
